export default __webpack_public_path__ + "static/media/cp_geo_br.46d9eb52.svg";